import {
    combineReducers
} from 'redux';
import MapReducer from "./MapReducer";

const rootReducer = combineReducers({
    MapReducer
});

export default rootReducer;